const booking = {
  bookingInformation: "Buchungsinformation", // translated
  ourCancellationPolicy: "Unsere Widerrufsbelehrung", // translated
  thisAupersedesAnyCancellationPolicyInRemarksAbove: "Dies ersetzt alle Stornierungsbedingungen in den obigen Bemerkungen", // translated
  thisBookingIsNonNefundable: "Diese Buchung ist nicht erstattungsfähig", // translated
  paymentTerms: "Zahlungsbedingungen", // translated
  paymentWillBeTakenFromYourDefault: "Die Zahlung wird von Ihrem Standard abgezogen", // translated
  paymentMethod: "Bezahlverfahren", // translated
  afterTheFreeCancellationPeriodIfApplicable: "nach der kostenlosen Stornierungsfrist, falls zutreffend", // translated
  prebook: "Vorbestellen", // translated
  guests: "Gäste", // translated
  payment: "Zahlung", // translated
  byClicking: "Beim Klicken", // translated
  youAreAgreeingToOur: "Sie stimmen unseren zu", // translated
  termsAndConditions: "Geschäftsbedingungen", // translated
  lastBookableDate: "Letztes buchbares Datum", // translated
  request: "Anfrage", // translated
  customerRemarksTextfield: "Kundenbemerkungen", // translated
};

export default booking;
